import {ResultType} from "../enums/result-type";

export class NormalTestRun {
  id?: number;
  parentId: number;
  isTheOne: boolean;
  runNumber: number;
  result: string;
  specialResult?: string;
  symbol?: string;
  resultEnteredDate: Date;
  comments: string;
  flag: string;
  reportAs: string;
  cutoff: string;

  constructor(parentId: number, isTheOne: boolean, runNumber: number, result: string, resultEnteredDate: Date, comments: string, flag: string, reportAs: string, cutoff: string, id?: number, specialResult?: string, symbol?: string) {
    this.id = id;
    this.parentId = parentId;
    this.isTheOne = isTheOne;
    this.runNumber = runNumber;
    this.result = result;
    this.specialResult = specialResult;
    this.symbol = symbol;
    this.resultEnteredDate = resultEnteredDate;
    this.comments = comments;
    this.flag = flag;
    this.reportAs = reportAs;
    this.cutoff = cutoff;
  }
}


export class PreviewNormalTestRun extends NormalTestRun {
  orderId: number;
  testId: number;
  unitOfMeasure: string;
  referenceRange: string;
  clinicalRangeComment: string;
  resultType: ResultType;

  constructor(orderId: number, testId: number, unitOfMeasure: string, referenceRange: string, clinicalRangeComment: string, resultType: ResultType, parentId: number, isTheOne: boolean, runNumber: number, result: string, resultEnteredDate: Date, comments: string, flag: string, reportAs: string, cutoff: string, id?: number, specialResult?: string, symbol?: string) {
    super(parentId, isTheOne, runNumber, result, resultEnteredDate, comments, flag, reportAs, cutoff, id, specialResult, symbol);
    this.orderId = orderId;
    this.testId = testId;
    this.unitOfMeasure = unitOfMeasure;
    this.referenceRange = referenceRange;
    this.clinicalRangeComment = clinicalRangeComment;
    this.resultType = resultType;
  }
}
